import { animate, style, transition } from '@angular/animations';
export const fadeScaleIf = [
  transition(':enter', [
    style({ opacity: 0, transform: 'scale(0.9)' }),
    animate('0.15s ease-out', style({ opacity: 1, transform: 'scale(1)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'scale(1)' }),
    animate('0.15s ease-out', style({ opacity: 0, transform: 'scale(0.9)' })),
  ]),
];
